// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"e4710d4c","602":"cd74f93f","787":"c096999d"}[chunkId] + ".chunk.js";
};